import { render } from "./IconSuccess.vue?vue&type=template&id=dcecfa28&scoped=true"
const script = {}

import "./IconSuccess.vue?vue&type=style&index=0&id=dcecfa28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcecfa28"]])

export default __exports__